import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { load as loadContent } from '../actions/content'
import { load as loadUsers } from '../actions/users'

import Loading from '../components/Loading'
import TypeHeader from '../components/TypeHeader'
import NoContent from '../components/help/NoContent'

import List from './LayoutList'
import Card from './LayoutCard'
import Tree from './LayoutTree'
import Table from './LayoutTable'

@connect((state, { section, type }) => {
  const content = section === 'types' ? state.content : state.users
  return {content: content[type.id]}
})
export default class Collection extends Component {
  static childContextTypes = {
    type: PropTypes.object
  }

  getChildContext () {
    const {type} = this.props
    return {type}
  }

  componentDidMount () {
    if (this.needsData()) this.fetchData(this.props)
  }

  componentWillReceiveProps (props) {
    if (this.needsData(props)) this.fetchData(props)
  }

  needsData ({ type, content } = this.props) {
    return type && !content
  }

  fetchData ({ type, dispatch, section }) {
    if (section === 'types') {
      dispatch(loadContent(type))
    } else {
      dispatch(loadUsers(type))
    }
  }

  renderContent () {
    const {type, content} = this.props
    const {layout} = type.options || {layout: 'default'}
    const props = {type, items: content}

    switch (layout) {
      case 'tree':
        return <Tree {...props} />
      case 'card':
      case 'grid':
        return <Card {...props} />
      case 'table':
        return <Table {...props} />
      default:
        return <List {...props} />
    }
  }

  render () {
    const {type, content} = this.props

    const isLoading = !content
    const hasContent = content && content.length > 0

    return <div className='wrap'>
      <div className='content scroll-container'>
        {type &&
          <TypeHeader type={type} />
        }
        {(isLoading && !hasContent) && <Loading type='padded' />}
        {!!hasContent && this.renderContent()}
        {(!hasContent && !isLoading) && <NoContent />}
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Collection.js